export const shippingMethodDriveProps = () => ({
  service: {
    type: Object,
    required: true
  },
  eligibleAlerteSms: {
    type: Boolean,
    required: false,
    default: false
  },
  hasChoixSacs: {
    type: Boolean,
    required: false,
    default: false
  },
  consigneSacs: {
    type: Boolean,
    required: false,
    default: false
  },
  isSacOffert: {
    type: Boolean,
    required: false,
    default: false
  },
  infosModeCommande: {
    type: Object,
    required: false,
    default: null
  }
})

export const useShippingMethodDrive = (props) => {
  const avecSacs = ref(null);
  const error = ref(null);
  const sacsDriveIsError = ref(false);
  const setChoixSacs = (data) => {
    sacsDriveIsError.value = false;
    avecSacs.value = data
  }

  const montantSac = computed(() => {
    return props.infosModeCommande && props.infosModeCommande.consigne_sacs && props.infosModeCommande.consigne_sacs.montant_unitaire
  })

  return {
    avecSacs,
    error,
    sacsDriveIsError,
    montantSac,
    setChoixSacs
  }
}